import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const ListHolidaysEtcPage = loadable(() => import('./ListHolidaysEtcPage'), {
    fallback: <Loader/>,
});
const AddHolidaysEtcPage = loadable(() => import('./AddHolidaysEtcPage'), {
    fallback: <Loader/>,
});
const EditHolidaysEtcPage = loadable(() => import('./EditHolidaysEtcPage'), {
    fallback: <Loader/>,
});
const HolidaysEtcRoute = ({ t , alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListHolidaysEtcPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddHolidaysEtcPage t={t} alert={alert} />} />
      <Route exact path='/edit/:id' element={<EditHolidaysEtcPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
HolidaysEtcRoute.propTypes = {
  t: PropTypes.func
};
export default HolidaysEtcRoute;
